/**
 * @file ppde页成员
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';
import MemberItem from './MemberItem';
import {IMemberItem, IMembersProps} from './types';

const Members: React.FC<IMembersProps> = (props) => {
    const {
        list,
        sortBy
    } = props;

    const theListMap = useMemo<{ [key: string]: IMemberItem[] }>(() => {
        let entryTimeList = list.slice(0);
        // entryTimeList.sort((a, b) => {
        //     if (a.entryTime && b.entryTime) {
        //         return b.entryTime.unix() - a.entryTime.unix();
        //     }
        //     return 0;
        // });
        // const maxEntryTimeMounth = entryTimeList[0]?.entryTime;
        // if (maxEntryTimeMounth) {
        //     entryTimeList = entryTimeList.filter(i => i.entryTime.isSame(maxEntryTimeMounth, 'month'));
        // }
        const nameList = list.slice(0);
        nameList.sort((a, b) => {
            const a2 = a.name ?? '';
            const b2 = b.name ?? '';
            return a2.localeCompare(b2);
        });
        return {
            entryTime: entryTimeList.slice(-20).reverse(),
            name: nameList
        };
    }, [list]);

    const theList = useMemo(() => {
        const key = sortBy || '';
        return theListMap[key] || [];
    }, [theListMap, sortBy]);


    return (
        <div className="paddle-ppde-members">
            <div className="paddle-ppde-members-row">
                {theList.map((item, index) => (
                    <div className="paddle-ppde-members-col" key={index}>
                        <MemberItem
                            {...item}
                            backgroundType={index % 3 + 1}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Members;
